<template>
  <div>
    <el-card>
      <!-- 搜索与添加区域 -->
      <el-collapse accordion>
        <el-collapse-item>
          <template slot="title">
            <el-row :gutter="20">
              <el-col :span="8">
                <el-input placeholder="请输入标题" v-model.trim="queryInfoparams.params.keyword" clearable
                 @change="search"
                  @clear="queryInfoparams.params.keyword==null"
                ></el-input>
              </el-col>
              <el-col :span="8">
                <el-button class="collapseBtn" plain icon="el-icon-search" @click="search">查询</el-button>
              </el-col>
            </el-row>
          </template>
        </el-collapse-item>
      </el-collapse>
      <el-row type="flex" justify="end">
        <el-col class="searchBtns" :span="6">
          <el-button-group>
            <el-button plain size="small" icon="el-icon-plus" v-hasPermission="['notify:save']" @click="openAddDialog">新增</el-button>
          </el-button-group>
        </el-col>
      </el-row>
      <!-- 协议列表区域 -->
      <el-table :data="dataList" border stripe>
        <el-table-column type="index" label="No."></el-table-column>
        <el-table-column label="标题" sortable prop="title"></el-table-column>
        <el-table-column label="状态" sortable>
          <template slot-scope="scope">
            <el-tag v-if="scope.row.status === 'Y'" type="success">有效</el-tag>
            <el-tag v-else-if="scope.row.status === 'N'" type="info">无效</el-tag>
          </template>
        </el-table-column>
        <el-table-column label="有效开始时间" sortable prop="startTime"></el-table-column>
        <el-table-column label="更新时间" prop="updatedTime"></el-table-column>

        <el-table-column label="是否置顶" sortable>
          <template slot-scope="scope">
            <el-tag v-if="scope.row.isTop === 'Y'" type="success">是</el-tag>
            <el-tag v-else-if="scope.row.isTop === 'N'" type="info">否</el-tag>
          </template>
        </el-table-column>
        <el-table-column label="已读人数"  prop="totalRead">
            <template slot-scope="scope">
              {{scope.row.totalRead}}/{{scope.row.total}}
          </template>
        </el-table-column>
        <el-table-column label="操作" width="180px">
          <template slot-scope="scope">
            <!-- 修改按钮 -->
            <el-link icon="el-icon-edit" v-hasPermission="['notify:save']" @click="showEditDialog(scope.row.id)">编辑</el-link>
            <el-link v-if="scope.row.isTop === 'N'" icon="el-icon-setting" v-hasPermission="['notify:save']" @click="setTop(scope.row.id)">置顶</el-link>
            <el-link v-if="scope.row.isTop === 'Y'" icon="el-icon-setting" v-hasPermission="['notify:save']" @click="setNotTop(scope.row.id)">取消置顶</el-link>
          </template>
        </el-table-column>
      </el-table>
      <!-- 分页区域 -->
      <el-pagination
        @size-change="handleSizeChange"
        @current-change="handleCurrentChange"
        :current-page="queryInfoparams.current"
        :page-sizes="[10, 50, 100, 200]"
        :page-size="queryInfoparams.size"
        layout="total, sizes, prev, pager, next, jumper"
        :total="total"
      ></el-pagination>
    </el-card>

    <!-- 对话框 -->
    <el-dialog :title="dialogTitle" :visible.sync="dialogVisible" width="70%" top="30px" @close="dialogClosed">
      <!-- 内容主体区域 -->
      <el-form :model="addForm" :rules="addFormRules" ref="addFormRef" label-width="70px">
        <el-form-item label="标题" label-width="90px" prop="title">
          <el-input v-model="addForm.title"></el-input>
        </el-form-item>
        <el-form-item label="选择角色" label-width="90px"  prop="roleIdList">
         <el-select
            v-model="addForm.roleIdList"
            multiple
            placeholder="请选择角色权限"
          >
            <el-option
              v-for="item in roleList"
              :key="item.id"
              :label="item.role_name"
              :value="item.id"
            ></el-option>
          </el-select>
        </el-form-item>
        <el-row>

          <el-col :span="12">
             <el-form-item label="开始时间" label-width="90px" prop="startTime">
                <el-date-picker
                v-model="addForm.startTime"
                 type="datetime"
                 format="yyyy-MM-dd HH:mm:ss"
                 value-format="yyyy-MM-dd HH:mm:ss"
                placeholder="选择时间">
              </el-date-picker>
              </el-form-item>
            </el-col>
            <el-col :span="12">
               <el-form-item label="状态" prop="status" label-width="100px">
                <el-radio-group v-model="addForm.status">
                  <el-radio label="Y">生效</el-radio>
                  <el-radio label="N">失效</el-radio>
                </el-radio-group>
              </el-form-item>
          </el-col>
        </el-row>
       
        <el-form-item label="内容" label-width="90px" prop="content">
          <editor
            v-model="addForm.content"
            class="set-wang"
            :isClear="isClear"
            @change="changeEditor"
          ></editor>
        </el-form-item>
 
      </el-form>
      <!-- 底部区域 -->
      <span slot="footer" class="dialog-footer">
        <el-button @click="dialogVisible = false">取 消</el-button>
        <el-button type="primary" @click="save">保存</el-button>
      </span>
    </el-dialog>
  </div>
</template>
<script>
import Editor from '@/components/editor/Editor'
export default {
  components: {
    Editor,
  },
  data() {
    return {
      editor: null,
      editorData: '',
      roleList:[],

      // 获取用户列表的参数对象
      queryInfoparams: {
        // 当前页码
        current: 0,
        // 查询参数
        params: {},
        // 当前每页显示多少条数据
        size: 10,
        // 排序字段
        sortField: '',
        // ASC  DESC 顺序
        sortOrder: '',
      },
      total: 0,
      //返回协议列表
      dataList: [],
      dialogVisible: false,
      // 控制编辑协议对话框的显示与隐藏
      editDialogVisible: false,
      addForm: {
        status: 'Y',
      },
      addForm: {},
      // 添加表单的验证规则对象
      addFormRules: {
        title: [{ required: true, message: '标题不能为空', trigger: 'blur' }],
        roleIdList: [{ required: true, message: '角色不能为空', trigger: 'blur' }],
        startTime: [{ required: true, message: '开始时间不能为空', trigger: 'blur' }],
        content: [
          { required: true, message: '请输入内容', trigger: 'blur' },
          {
            trigger: 'blur',
          },
        ],
        setRoleDialogVisible: false,

      },
      wangContent: '',
      isClear: false,

      dialogTitle:'',
    }
  },
  methods: {
    //获取角色列表
    getRoleList(){
       this.$get(`role/selectByType/ALL`).then(({ data: res }) => {
        console.log(res)
        var list= res.data
        this.roleList = []

        for(var i=0;i<list.length;i++){
          this.roleList.push({id:list[i].id,role_name:list[i].role_name+'('+list[i].remark+')'})
        }
      })
    },
    // 打开新增弹窗
    openAddDialog() {
      this.getRoleList()
      this.dialogTitle='新增'
      this.dialogVisible = true
    },
     // 监听添加协议对话框的关闭事件
    dialogClosed() {
      this.addForm={status:'Y'}
      this.$refs.addFormRef.resetFields()
      this.dialogVisible = false
    },
    // 展示编辑的对话框
    async showEditDialog(id) {
      this.getRoleList()
      this.$get(`notify/get/${id}/Y`).then(({ data: res }) => {
        this.addForm = res.data
         this.dialogVisible = true
         this.dialogTitle='编辑'
      })
    },
    getEditorData() {
      // 通过代码获取编辑器内容
      let data = this.editor.txt.html()
      // console.log('data', data)
      // alert(data)
    },
    search(){
        this.queryInfoparams.current=0
         this.getDataList()
    },
    async getDataList() {
      this.$post('/notify/pageQuery', this.queryInfoparams).then(
        ({ data: res }) => {
          this.dataList = res.records
          this.total = res.total
          console.log('协议', res)
        }
      )
    },
    // 监听pagesize改变的事件
    handleSizeChange(newSize) {
      this.queryInfoparams.size = newSize
      this.getDataList()
    },
    // 监听页码值 改变的事件
    handleCurrentChange(newPage) {
      this.queryInfoparams.current = newPage
      this.getDataList()
    },

    //设置置顶
    async setTop(id){
      this.$get(`notify/setTopOrNot/${id}`).then(({ data: res }) => {
        console.log("置顶"  , res)
          if (!res.ok){
              return this.$message.error("operation failed")
          }
           this.getDataList()
           return this.$message.success("Successful operation")
      })
    },
    //设置取消置顶
    async setNotTop(id){
      this.$get(`notify/setTopOrNot/${id}`).then(({ data: res }) => {
          if (!res.ok){
              return this.$message.error("operation failed")
          }
          this.getDataList()
          return this.$message.success("Successful operation")
      })
    },


    // 点击按钮 添加新协议
    async save() {
      this.$refs.addFormRef.validate(async (valid) => {
        if (!valid) return
        var tempList = this.addForm.roleIdList
         this.addForm.roleIds = this.addForm.roleIdList.join(',')

        this.addForm.roleIdList = null

        this.$postFile('notify/save', this.addForm).then(({ data: res }) => {
          console.log(res.msg)
          if (! res.ok) {
            this.addForm.roleIdList=tempList
            return this.$message.error(res.msg)
          }
         
          this.$message.success(res.msg)
          // 隐藏的对话框
          this.dialogClosed()
          // 刷新户协议数据
          this.getDataList()
        })
      })
    },

    changeEditor(data) {
      this.addForm.context = data
    },
  },
  created() {
    this.search()
  },
}
</script>
<style lang="less" scoped>
.el-select {
  width: 100%;
}
/deep/.el-collapse-item__content {
  display: flex;
  justify-content: space-between;
}
.collapseBtn {
  height: 40px;
}
.searchBtns {
  flex: 1;
  display: flex;
  justify-content: flex-end;
}
/deep/.el-collapse-item__wrap {
  border: none !important;
}
/deep/.el-collapse-item__header {
  border: none !important;
}
.el-row {
  flex: 1;
}
.home {
  width: 1200px;
  margin: auto;
  position: relative;
  .btn {
    position: absolute;
    right: 0;
    top: 0;
    padding: 5px 10px;
    cursor: pointer;
  }
  h3 {
    margin: 30px 0 15px;
  }
}
</style>